import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default function ViewExpression() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const contentRef = useRef();

  useEffect(() => {
    axios.get(`https://testing.sttar.in/api/expressions_interest/${id}`)
      .then(res => {
        setData(res.data.quetions);
        setLoading(false);
      })
      .catch(err => {
        setError('Unable to fetch details.');
        setLoading(false);
      });
  }, [id]);

  const downloadPDF = () => {
    const input = contentRef.current;
    html2canvas(input).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`expression-details-${id}.pdf`);
    });
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!data) return <p>No data found.</p>;

  return (
    <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <h2>Expression of Interest Details</h2>
      <div ref={contentRef} style={{ width: '60%', border: '1px solid #ccc', padding: '20px', borderRadius: '10px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {Object.entries(data).map(([key, value]) => (
              <tr key={key}>
                <td style={{ fontWeight: 'bold', padding: '8px', border: '1px solid #ccc' }}>{key.replace(/_/g, ' ').toUpperCase()}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{value ? value.toString() : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button onClick={downloadPDF} style={{ marginTop: '20px', padding: '10px 20px' }}>Download PDF</button>
    </div>
  );
}
